export const formatAddress = (address: string) => {
  const split = address.split(',');

  return `${split[0]}, <br /> ${split[1]}`;
};
